import React, { ReactElement } from 'react';
import { Button, ButtonProps, useClipboard, useToast } from '@chakra-ui/react';
import { MdContentCopy } from 'react-icons/md';

const CopyButton = ({ text, ...rest }: ButtonProps & { text: string }): ReactElement => {
  const toast = useToast();

  const { onCopy } = useClipboard(text);
  return (
    <Button
      display="flex"
      alignItems="center"
      height="16px"
      borderRadius="sm"
      minWidth="16px"
      padding="0"
      pb="1"
      aria-label="copy"
      variant="ghost"
      onClick={e => {
        e.stopPropagation();
        onCopy();
        toast({
          title: 'Content copied to clipboard',
          status: 'info',
          duration: 1000,
          isClosable: true,
        });
      }}
      {...rest}
      color="purple.100"
    >
      <MdContentCopy />
    </Button>
  );
};
export default CopyButton;
